// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Order_item_requests_SalvarTodosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for POST /so/order_item_requests/salvar_todos/{order_item_id}
 *
 * Bulk-replace endpoint. Emits an empty success envelope (no dados
 * payload) — the model writes the new request set transactionally.
 *
 * @see So_order_item_requests_model::replaceForOrderItem()
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Order_item_requests_SalvarTodosResponseDados = null;

export type Order_item_requests_SalvarTodosResponse = ApiResponse<Order_item_requests_SalvarTodosResponseDados>;

registerResponseContract('Order_item_requests_SalvarTodosResponse', {})
